import React, { useEffect, useState } from 'react';
import { useScript } from '../src/hooks';

import Head from 'next/head';
import getMetaTagData from '../src/common/services/getMetaTagData';
import MainTop from '../src/component/pc/maintop/MainTop';
import MainBottom from '../src/component/pc/MainBottom/MainBottom';

function Report({ metaTagData, jWTCheck }) {
  const [reRenderCheck, setReRenderCheck] = useState(true);
  const sectionStyle = {
    backgroundImage: 'url(styles/2022/pc/img/vision_icon_01.png)'
  };

  const status = useScript('//board.sbs.co.kr/pc/js/sbs_board_module.js');
  useEffect(() => {
    try {
      if (status === 'ready') {
        const option = {
          board_code: 'multiboard_all_65947', // 게시판 코드 필수
          root_element_type: 'I', // 댓글이 들어갈 Element Name의 타입(I:아이디, C:클래스)
          root_element_name: 'boardModuleWrap', // 댓글이 추가될 Element Name
          cmd: 'multi_list' // 댓글 모듈은 필수
        };
        const board = new SBSBoardModule(option);
        board.init();
      }
    } catch (error) {
      console.log(error);
    }
  }, [status]);

  // gtag
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', 'UA-104756746-1');
      gtag('config', 'G-L9E7Y63ZNE');
    }
  }, []);

  return (
    <>
      <script async src='https://www.googletagmanager.com/gtag/js?id=UA-104756746-1' />
      <Head>
        <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL} />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <meta name='description' content='SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={'' || ''} />
        <meta property='og:description' content={'SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' || ''} />
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={'' || ''} />
        <meta name='nate:description' content={'SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <script type='text/javascript' src='//static.cloud.sbs.co.kr/common/js/jquery-1.10.2.min.js' />
        <link rel='stylesheet' type='text/css' href='//static.cloud.sbs.co.kr/pc/css/sbs_common.css' media='all' />
        <link rel='stylesheet' type='text/css' href='//board.sbs.co.kr/pc/css/board-1.0.0.min.css' media='all' />
        {/* <script type='text/javascript' id='SBSBoardModule' src='//board.sbs.co.kr/pc/js/sbs_board_module.js' /> */}
        <script type='text/javascript' src='//developers.kakao.com/sdk/js/kakao.min.js' />

        <title>보도자료 : SBS 소개 : SBS</title>

      </Head>

      <ul id='skip_nav'>
        <li><a href='#container'>본문컨텐츠</a></li>
        <li><a href='#header'>헤더 메뉴</a></li>
      </ul>

      <div id='wrap' className='sbsabout_wrap '>
        {/* <!-- 헤더 --> */}
        <MainTop />
        {/* <!-- 컨텐츠영역 --> */}
        <div id='container' className='contents'>
          <h2 className='hide'>SBS</h2>
          {/* <!-- 비쥬얼영역 --> */}
          <div className='sbsabout_visual_top_report' style={sectionStyle}>
            <div className='sbsabout_inner'>
              <h3 className='sbsabout_visual_title'>보도자료</h3>
            </div>
          </div>
          {/* <!-- 컨텐츠 --> */}
          <div className='sbstemplate_contents_w'>
            <div id='boardModuleWrap' />
          </div>
        </div>

        {/* <!-- 풋터 --> */}
        <MainBottom />
      </div>

    </>
  );
}

export async function getServerSideProps(ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;

  const jWTCheck = !!LOGIN_JWT;
  const metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory);

  return { props: { metaTagData, jWTCheck } };
}

export default Report;
